export default () => {
    return {
        mounted() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.hero,
                    scrub: true,
                    start: 'top top',
                    end: 'bottom top'
                }
            });

            parallax.fromTo(
                this.$refs.dots,
                {
                    yPercent: 0
                },
                {
                    yPercent: 70,
                    ease: 'none'
                }
            );

            if (this.$refs.content) {
                parallax.fromTo(
                    this.$refs.content,
                    {
                        yPercent: 0
                    },
                    {
                        yPercent: -30,
                        ease: 'none'
                    },
                    '<0'
                );
            }
        }
    };
};
